<template>
	<!-- Custom item cho translate language -->
	<li
		class="combobox-item single translate-language-item"
		:class="{ parent: item.isParent, selected: isSelected }"
		:style="'text-align: ' + align"
		v-if="comboType === 1 && isCustomTranslateLanguage"
		v-on="listeners"
	>
		<div class="combobox-item-con">
			<div class="language-content">
				<div class="title-language">{{ item.title }}</div>
				<div class="subtitle-language">{{ item.subtitle }}</div>
			</div>
			<div class="tick-icon" v-if="isSelected">
				<div class="mi-new mi-24 mi-icon-tick"></div>
			</div>
		</div>
	</li>
	<!-- Item của combo không có column -->
	<li
		class="combobox-item single"
		:class="{ parent: item.is_parent }"
		:style="'text-align: ' + align"
		v-else-if="comboType === 1"
		v-on="listeners"
	>
		<div class="combobox-item-con">
			<div class="combobox-item--text" :title="getItemDisplay(item)">
				{{ getItemDisplay(item) }}
			</div>
			<span
				class="trash-icon"
				v-if="hasRemoveItemButton"
				@click="onRemoveItemClick()"
			>
				<span class="mi mi-16 mi-garbage"></span>
			</span>
		</div>
	</li>
	<li
		class="combobox-item single"
		:class="[
			{ parent: item.isParent },
			{ 'combobox-item-custom': isCustomComboxOrg },
			{ 'org-notemail': !item.InvRevEmail },
			indexItem >= 0 ? `transform-translate-item-${indexItem}` : ''
		]"
		:style="'text-align: ' + align"
		v-else-if="comboType === 3 && columnx.length == 0 && isCustomComboxOrg"
		v-on="listeners"
	>
		<div class="combobox-item-con">
			<div
				:class="[
					item.level ? `level-${item.level}` : `level-0`,
					item.Childrens && item.Childrens.length > 0
						? 'font-bold'
						: ''
				]"
			>
				<div class="ms-text-overflow" v-if="item.Name" :title="item.Name">
					<span class="font-bold">{{ item.Name }}</span>
				</div>
				<div v-if="item.InvRevEmail" class="">
					{{ $t('i18nCommon.EmailReceive')}}:
					<span style="color:#00A2CF">{{ item.InvRevEmail }}</span>
				</div>
			</div>
			<span
				class="trash-icon"
				v-if="hasRemoveItemButton"
				@click="onRemoveItemClick()"
			>
				<span class="mi mi-16 mi-garbage"></span>
			</span>
		</div>
	</li>
	<li
		class="combobox-item single"
		:class="[{ parent: item.isParent }]"
		:style="'text-align: ' + align"
		v-else-if="comboType === 3 && columnx.length == 0"
		v-on="listeners"
	>
		<div class="combobox-item-con">
			<div
				class=""
				:class="[
					item.level ? `level-${item.level}` : `level-0`,
					item.Childrens && item.Childrens.length > 0
						? 'font-bold'
						: ''
				]"
				:title="getItemDisplay(item)"
			>
				{{ getItemDisplay(item) }}
			</div>
			<span
				class="trash-icon"
				v-if="hasRemoveItemButton"
				@click="onRemoveItemClick()"
			>
				<span class="mi mi-16 mi-garbage"></span>
			</span>
		</div>
	</li>
	<!-- Item của combo có column -->
	<tr
		class="combobox-item"
		:class="{ parent: item.isParent }"
		v-else
		v-on="listeners"
	>
		<td
			class="combobox-item-td"
			v-for="(column, tdIndex) in columnx"
			:ref="`td-${tdIndex}`"
			:key="column.dataField"
			:class="
				comboType === 3 && tdIndex === 0 ? `level-${item.level}` : null
			"
			:style="getTdStyle(column, tdIndex)"
		>
			<div class="combobox-item-td--contents">
				<div
					:title="getItemDisplay(item, column)"
					class="combobox-item-td--text"
				>
					{{ getItemDisplay(item, column) }}
				</div>
			</div>
		</td>
		<td class="selected-container" v-if="item.multiSelected">
			<div class="selected"></div>
		</td>
	</tr>
</template>

<script>
export default {
	name: 'MsComboBoxItemV2',
	props: {
		/**
		 * Loại combo
		 */
		comboType: {
			type: Number,
			default: 1
		},

		/**
		 * Item sử dụng để binding
		 */
		item: {},

		/**
		 * Cấu hình cột của menu
		 */
		columnx: {
			type: Array,
			default: []
		},
		/**
		 * Trường làm value
		 * CreatedBy PDKIEN 10/12/2019
		 */
		valueField: {
			type: String,
			default: null
		},
		/**
		 * Trường là display
		 * CreatedBy PDKIEN 10/12/2019
		 */
		displayField: {
			type: String,
			default: null
		},

		/**
		 * Trạng thái có btn `Xóa` trong item
		 */
		hasRemoveItemButton: {
			type: Boolean,
			default: false
		},
		/**
		 * Kiểu định dạng dữ liệu trên combobox
		 * Tương ứng với FormatType
		 * CreatedBy PDKIEN 07/12/2019
		 */
		formatType: {
			type: [Number, String],
			default: null
		},
		align: {
			type: String,
			default: 'left'
		},
		//Custom lại combobox cho chi nhánh hình cây
		isCustomComboxOrg: {
			type: Boolean,
			default: false
		},
		//Custom lại combobox cho translate language
		isCustomTranslateLanguage: {
			type: Boolean,
			default: false
		},
		indexItem: {
			type: Number,
			default: null
		},
		//Giá trị được chọn để hiển thị icon tick
		selectedValue: {
			default: null
		}
	},
	computed: {
		/**
		 * Binding sự kiện của menu item
		 */
		listeners() {
			const me = this;
			return {
				...me.$listeners
			};
		},
		/**
		 * Kiểm tra item hiện tại có được chọn không
		 */
		isSelected() {
			const me = this;
			if (!me.valueField || !me.selectedValue) return false;
			return me.item[me.valueField] === me.selectedValue;
		}
	},
	mounted() {
		const me = this;
		if (me.indexItem >= 0) {
			let itemElement = document.querySelector(
				`transform-translate-item-${me.indexItem}`
			);
			if (itemElement && itemElement.length > 0) {

			}
		}
	},
	methods: {
		/**
		 * Hàm lấy style cho td trong table
		 * dữ liệu động theo config của dev
		 */
		getTdStyle(column, index) {
			if (column.isResize) {
				if (
					this.$refs[`td-${index}`] &&
					this.$refs[`td-${index}`].length > 0
				) {
					let item = this.$refs[`td-${index}`][0];
					let rectTd = item.getBoundingClientRect();
					let rectParent = this.$parent.$el.getBoundingClientRect();
					if (rectTd.right <= rectParent.right) {
						return {
							width:
								rectTd.width +
								(rectParent.right - rectTd.right) +
								'px',
							textAlign: column.columnAlign
						};
					} else {
						return {
							width: `${column.width}px`,
							textAlign: column.columnAlign
						};
					}
				}
			}
			return {
				width: column.isResize ? null : `${column.width}px`,
				textAlign: column.columnAlign
			};
		},

		/**
		 * Lấy text hiển thị trên item
		 * Nếu có column lấy theo column.field, nếu không có column lấy theo displayField, nếu không có displayField lấy theo valueField
		 * CreatedBy PDKIEN 10/12/2019
		 */
		getItemDisplay(item, column) {
			let field = column
				? column.dataField
				: this.displayField || this.valueField;
			if (field) {
				return item[field];
			} else {
				return item;
			}
		},

		getValueField(item, column) {
			let field = column
				? column.dataField
				: this.valueField;
			if (field) {
				return item[field];
			} else {
				return item;
			}
		},

		/**
		 * Xử lý sự kiện khi click icon xóa item
		 */
		onRemoveItemClick() {
			this.$emit('removeItem');
		}
	}
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';
@media screen and (max-width: 1366px) {
	@import '@/assets/scss/_sm-variables.scss';
	@import '@/assets/scss/components/msComboboxItem.scss';
}
@media screen and (min-width: 1367px) {
	@import '@/assets/scss/_variables.scss';
	@import '@/assets/scss/components/msComboboxItem.scss';
}

.combobox-item-custom {
	line-height: unset;
	width: 100%;
	min-height: 40px;
	display: flex !important;
	align-items: center;
}
.org-notemail {
	cursor: unset;
	&:hover {
		background: unset;
	}
}

.ms-text-overflow{
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	width: 650px;
}

.translate-language-item {
	padding: 12px 18px;
	margin-bottom: 4px;
	min-height: 58px;
	display: flex;
	align-items: center;
	border: none !important;
	
	&:hover {
		border: none !important;
	}
	
	&:active {
		border: none !important;
	}
	
	&.selected {
		border: none !important;
	}
	
	.combobox-item-con {
		width: 100%;
		display: flex;
		align-items: center;
	}
	
	.language-content {
		display: flex;
		flex-direction: column;
		gap: 6px;
		flex: 1;
		
		.title-language {
			font-size: 14px;
			font-weight: 600;
			line-height: 1.3;
			color: #212529;
		}
		
		.subtitle-language {
			font-size: 12px;
			line-height: 1.3;
			color: #63676D;
			opacity: 0.85;
		}
	}
	
	.tick-icon {
		display: flex;
		align-items: center;
		justify-content: center;
		margin-left: 12px;

		.mi-icon-tick {
			color: $ms-color-primary;
			opacity: 0.8;
		}
	}
}

</style>
